import { render, staticRenderFns } from "./financialCollect.vue?vue&type=template&id=854a52d6&scoped=true"
import script from "./financialCollect.vue?vue&type=script&lang=js"
export * from "./financialCollect.vue?vue&type=script&lang=js"
import style0 from "./financialCollect.vue?vue&type=style&index=0&id=854a52d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854a52d6",
  null
  
)

export default component.exports